import React from "react";
import { Box } from "rebass/styled-components";
import styled from "styled-components";
import { Image } from "rebass/styled-components";
import { ReactComponent as AllstarLogo } from "../../../assets/images/logo/amarktag.svg";
import { ReactComponent as BrandAllstarLogo } from "../../../assets/images/logo/logo.svg";
import { ReactComponent as TagAllstarLogo } from "../../../assets/images/logo/taglogo.svg";
import { ReactComponent as BrandASymbol } from "../../Assets/Brand/A-Mark-Light.svg";
function Tagline(props) {
  return <Image src={TagAllstarLogo} fill="currentColor" {...props} />;
}
export function ABrandSymbol(props) {
  return <BrandASymbol {...props} />;
}
function Brand(props) {
  return <Logo as={BrandAllstarLogo} fill="currentColor" {...props} />;
}

function AMarkAllstarLogo(props) {
  return <Box as={AllstarLogo} fill="currentColor" {...props} />;
}

const Logo = styled(Box)`
  display: block;
`;
